/**
 * Level fallback mapping configuration
 * See https://confluence.collaboration-man.com/spaces/MANWS/pages/359773463/Affected+Products+for+Evergreen+Migration
 */
const fallbackConfig: Record<string, Record<string, string>> = {
    'man-sku00000005': { '10': '15' },
    'rio-sku00000027': { '10': '15' },
    'rio-sku00000047': { '10': '15' },
    'man-sku00000049': { '10': '15' },
    'man-sku00000050': { '10': '15', '20': '25' },
    'rio-sku00000055': { '10': '15' },
    'rio-sku00000056': { '10': '15' },
    'man-sku00000066': { '10': '15' },
    'man-sku00000073': { '10': '15', '20': '25' },
    'man-sku00000085': { '10': '15' },
    'rio-sku00000096': { '10': '15' },
    'man-sku00000098': { '10': '15' },
};

const FALLBACK_LEVEL_SWITCH_TIMESTAMP = Date.parse('2026-09-01T00:00:00Z');
const FALLBACK_LEVELS_AFTER_SWITCH: Record<string, string> = {
    '15': '14',
    '25': '24',
};

/**
 * Returns the fallback level for a given product and level combination if fallback is enabled.
 * If fallback is disabled or no mapping exists, returns the original level.
 *
 * @param productId - The product SKU ID (case-insensitive)
 * @param level - The requested level
 * @param fallbackEnabled - Whether the fallback feature is enabled
 * @returns The fallback level or the original level
 */
export function getFallbackLevel(
    productId: string,
    level: string | undefined,
    fallbackEnabled: boolean
): string | undefined {
    if (!fallbackEnabled || !level) {
        return level;
    }

    const normalizedProductId = productId.toLowerCase();
    const productFallback = fallbackConfig[normalizedProductId];
    if (!productFallback) {
        return level;
    }

    const configuredFallbackLevel = productFallback[level];
    const isConfiguredFallbackTarget = Object.values(productFallback).includes(level);
    if (!configuredFallbackLevel && !isConfiguredFallbackTarget) {
        return level;
    }

    const fallbackLevel = configuredFallbackLevel ?? level;

    return Date.now() >= FALLBACK_LEVEL_SWITCH_TIMESTAMP
        ? (FALLBACK_LEVELS_AFTER_SWITCH[fallbackLevel] ?? fallbackLevel)
        : fallbackLevel;
}
